export const suspenseAdapter = (promise) => {
  let res = null;
  const setResult = (result) => {
    res = { result };
  };
  const setError = (error) => {
    res = { error };
  };
  const p = promise.then(setResult, setError);

  return () => {
    if (res === null) {
      throw p;
    }
    return res;
  };
};
